import React, {useState} from 'react';
import {
  ArtistCollectioneItem,
  Box,
  GridBox,
  StudioDesignSystem,
} from '@ttx/design-system';
import {useRouter} from 'next/router';
import {Collection} from '../../server/router/collection/types';

const StudioArtistCollectioneItem = StudioDesignSystem.ArtistCollectioneItem;

interface CollectionViewProps {
  collectionList: Collection[];
  isMobile: boolean;
  onExploreCollection: (arg: any) => void;
  isStudio?: boolean;
}

export const CollectionView: React.FC<CollectionViewProps> = ({
  collectionList,
  isMobile,
  onExploreCollection,
  isStudio,
}: CollectionViewProps) => {
  if (!collectionList.length) {
    return null;
  }

  const onExplore = (e: Collection) => {
    onExploreCollection({title: e.title, id: e._id});
  };

  return (
    <div>
      <Box
        borderColor="grey32"
        borderStyle="solid"
        borderTopWidth="zero"
        borderRightWidth="zero"
        borderLeftWidth="zero"
        borderBottomWidth="zero"
        marginTop="eight"
        minHeight="500px"
        height="auto"
        width="10o%"
        marginBottom="twelve"
      >
        {collectionList.map((e, i) => {
          return (
            <div key={e._id}>
              {isStudio ? (
                <StudioArtistCollectioneItem
                  key={e._id}
                  imageSrc={e.thumbnail}
                  title={e.title}
                  network={
                    e.blockchainNetworkDetail.network
                      ? e.blockchainNetworkDetail.network.toUpperCase()
                      : 'ETH'
                  }
                  description={e.description}
                  collectionId={e._id}
                  nftCount={e.nftTokenIds.length}
                  isLeft={i % 2 === 0}
                  isMobile={isMobile}
                  artistName={e.creatorDetails.user.displayName}
                  artistImg={e.creatorDetails.user.image}
                  onExplore={() => onExplore(e)}
                />
              ) : (
                <ArtistCollectioneItem
                  key={e._id}
                  imageSrc={e.thumbnail}
                  title={e.title}
                  network={
                    e.blockchainNetworkDetail.network
                      ? e.blockchainNetworkDetail.network.toUpperCase()
                      : 'ETH'
                  }
                  description={e.description}
                  collectionId={e._id}
                  nftCount={e.nftTokenIds.length}
                  isLeft={i % 2 === 0}
                  isMobile={isMobile}
                  artistName={e.creatorDetails.user.displayName}
                  artistImg={e.creatorDetails.user.image}
                  onExplore={() => onExplore(e)}
                />
              )}
            </div>
          );
        })}
      </Box>
    </div>
  );
};
